import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { ActivitiesPendingByProfessionalsUseCaseInterface } from 'domain/usecases';

export class RemoteActivitiesPendingByProfessionals
  implements ActivitiesPendingByProfessionalsUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<ActivitiesPendingByProfessionalsUseCaseInterface.Result>,
  ) {}

  async execute(
    params: ActivitiesPendingByProfessionalsUseCaseInterface.Params,
  ): Promise<ActivitiesPendingByProfessionalsUseCaseInterface.Result> {
    const requestUrl = generateUrl(this.url, params as any);

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: requestUrl,
      responseType: 'json',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
